import { requestWithPromise } from '../../utils'
import { arrayToUrlParameters, HttpMethods } from '../../utils/apiHelper'
import { SUCCESS_REQUEST_STATUS } from '../../utils/constants'
import { QUOTAS } from './actionsType'

const {
  SET_QUOTA, SET_QUOTAS, SET_QUOTAS_FOR_MULTIPLES_SECTORS, UPDATE_QUOTA, DELETE_QUOTA
} = QUOTAS

const getQuotas = state => {
  return state.quotas.quotas
}

const getQuotasState = state => {
  return state.quotas
}

const fetchSectorQuotas = (sectorId, user) => {
  return async (dispatch, getState) => {
    requestWithPromise('/api/quotas/' + sectorId,
      HttpMethods.GET,
      null,
      user,
      { catchError: false }
    ).then(jsonResponse => {
      if (jsonResponse && jsonResponse.data) {
        dispatch({
          type: SET_QUOTAS,
          payload: jsonResponse.data
        })
      }
    })
  }
}

const fetchSectorsQuotas = (sectorsIds, user) => {
  return async (dispatch, getState) => {
    requestWithPromise('/api/quotas?' + arrayToUrlParameters(sectorsIds, 'sectors') + '&by-ids=true',
      HttpMethods.GET,
      null,
      user,
      { catchError: false }
    ).then(jsonResponse => {
      if (jsonResponse && jsonResponse.data) {
        dispatch({
          type: SET_QUOTAS_FOR_MULTIPLES_SECTORS,
          payload: jsonResponse.data
        })
      }
    })
  }
}

const fetchInstitutionQuotas = (institutionId, user) => {
  return async (dispatch, getState) => {
    requestWithPromise(`/api/quotas?institution=${institutionId}&by-ids=true`,
      HttpMethods.GET,
      null,
      user,
      { catchError: false }
    ).then(jsonResponse => {
      if (jsonResponse && jsonResponse.data) {
        dispatch({
          type: SET_QUOTAS_FOR_MULTIPLES_SECTORS,
          payload: jsonResponse.data
        })
      }
    })
  }
}

const updateQuota = (quotaData, user) => {
  const quota = { ...quotaData }

  if (quota.school) {
    quota.school = quota.school?.id
  } else {
    quota.school = null
  }

  if (quota.sectionToYear) {
    quota.sectionToYear = quota.sectionToYear?.id
  } else {
    quota.sectionToYear = null
  }

  return async (dispatch, getState) => {
    requestWithPromise(`/api/quotas/${quota.id}`,
      HttpMethods.PATCH,
      quota,
      user
    ).then(jsonResponse => {
      if (jsonResponse && jsonResponse.data) {
        dispatch(updateReduxQuota(jsonResponse.data))
      }
    })
  }
}

const removeQuota = (quota, user) => {
  return async (dispatch, getState) => {
    requestWithPromise(`/api/quotas/${quota.id}`,
      HttpMethods.DELETE,
      null,
      user,
      { catchError: false }
    ).then(jsonResponse => {
      if (jsonResponse && jsonResponse.status === SUCCESS_REQUEST_STATUS) {
        dispatch({
          type: DELETE_QUOTA,
          payload: quota.id
        })
      }
    })
  }
}

export const setReduxQuota = quota => ({ type: SET_QUOTA, payload: quota })
export const updateReduxQuota = quota => ({ type: UPDATE_QUOTA, payload: quota })

export {
  getQuotas,
  getQuotasState,
  fetchSectorQuotas,
  fetchSectorsQuotas,
  fetchInstitutionQuotas,
  updateQuota,
  removeQuota
}
